import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './sampleDevelopmentNl.style';

import { CheckBoxFastField, TextFieldFastField } from '../../../components';

interface SamDevNlFinishingBackProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlFinishingBack: React.FC<SamDevNlFinishingBackProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}></Grid>
        <Grid item xs={4}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="finishCoatingBack"
            label="Back"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}></Grid>
        <Grid item xs={4}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbFilmLaminate"
            label="Laminate Film"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbFilmMatt" label="Matt" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbFilmGloss" label="Gloss" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbFilmHalogram"
            label="Halogram"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbFilmOther" label="Other" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <Typography className={classes.numberTitle} display="inline" />
        </Grid>
        <Grid item xs={4}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemCemical"
            label="Chemical"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemWaterBase"
            label="Water Base"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemOilBase"
            label="Oil Base"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbChemVanish" label="UV" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbChemSpot" label="Spot" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbChemSpotMatt" label="Matt" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotSuperMatt"
            label="Supper Matt"
          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotSemiGloss"
            label="Semi Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotGloss"
            label="Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotHighGloss"
            label="High Gloss"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotTexture"
            label="Texture"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotCalendering"
            label="Calendering"
          />
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={4} />
        <Grid item xs={1}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemSpotOther"
            label="Other"
          />
        </Grid>
        <Grid item xs={3}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckboxOther}
            name="fcbChemSpotOtherData"
            label="Other"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullArea"
            label="Full Area"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaMatt"
            label="Matt"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaSuperMatt"
            label="Supper Matt"
          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaSemiGloss"
            label="Semi Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaGloss"
            label="Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaHighGloss"
            label="High Gloss"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaTexture"
            label="Texture"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaCalendering"
            label="Calendering"
          />
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={4} />
        <Grid item xs={1}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbChemFullAreaOther"
            label="Other"
          />
        </Grid>
        <Grid item xs={3}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckboxOther}
            name="fcbChemFullAreaOtherData"
            label="Other"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbBlister" label="Blister" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbBlisterPet" label="PET" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbBlisterPvc" label="PVC" />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbSilkscreen"
            label="Silkscreen"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcbSilkFullArea"
            label="Full Area"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbSilkSpot" label="Spot" />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbSilkMatt" label="Matt" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbSilkGloss" label="Gloss" />
        </Grid>
        <Grid item xs={1}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcbSilkOthers" label="Other" />
        </Grid>
        <Grid item xs={3}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckboxOther}
            name="fcbSilkOthersData"
            label="Other"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}></Grid>
        <Grid item xs={4}>
          <CheckBoxFastField disabled={isCrtLocked} name="dieCutBack" label="Back" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutBHold"
            label="ปั๊มรู (Hold)"
          />
        </Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutBPerforate"
            label="ปั๊มปรุ (Perforate)"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutBShape"
            label="ปั๊มตามรูป (Shape)"
          />
        </Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutBFoldLine"
            label="ปั๊มพับ (Fold Line)"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutBEmboss"
            label="ปั๊มนูน (Emboss)"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SampleDevelopmentNlFinishingBack;
